var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#x-red';
                    var viewUrl = 'svg/icons.svg#view-x-red';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 14 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };